const gsapController = async function () {
    const circlesCharts = document.querySelector(".circle-chart") !== null;
    const quote = document.querySelector(".quote:not(.no-anima)") !== null;
    const heroAnimation = document.querySelector(".hero-animation") !== null;
    const markerAnimation = document.querySelector(".marker-animation") !== null;
    const circlesAnimation = document.querySelector(".circles-animation") !== null;
    const slidesAnimation = document.querySelector(".slides-animation-section") !== null;
    const scrollContent = document.querySelector(".scroll-content") !== null;
    const numberContent = !!document.querySelector(".number-content");
    const apps = !!document.querySelector(".number-content") !== null;
    const imageAndContent = !!document.querySelector(".image-and-content__animation") !== null;
    const centerAnimation = !!document.querySelector(".center-animation__animation") !== null;
    const heroDefaultAnimation = !!document.querySelector(".hero-default__animation") !== null;
    
    if ( circlesCharts || quote || heroAnimation || markerAnimation  || circlesAnimation || slidesAnimation || scrollContent || numberContent || apps || imageAndContent || centerAnimation || heroDefaultAnimation ) {
        let gsap = await (await import('gsap')).default;
        
        // ScrollTrigger
        if ( circlesCharts || quote || heroAnimation || markerAnimation || circlesAnimation || slidesAnimation || scrollContent || numberContent || apps || imageAndContent || centerAnimation|| heroDefaultAnimation ) {
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            gsap.registerPlugin(ScrollTrigger);

            if ( heroAnimation ) {
                let AnimatedSection = await (await import('./gsap/hero-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            // ScrollToPlugin
            if (slidesAnimation || scrollContent ) {
                let ScrollToPlugin = await (await import('gsap/ScrollToPlugin')).default;
                gsap.registerPlugin(ScrollToPlugin);

                if ( slidesAnimation ) {
                    let AnimatedSection = await (await import('./gsap/slides-animation')).default;
                    AnimatedSection(gsap, ScrollTrigger, ScrollToPlugin);
                }

                if ( scrollContent ) {
                    let AnimatedSection = await (await import('./gsap/scroll-content')).default;
                    AnimatedSection(gsap, ScrollTrigger, ScrollToPlugin);
                }
            }

            if ( quote ) {
                let AnimatedSection = await (await import('./gsap/quote')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            if ( markerAnimation ) {
                let AnimatedSection = await (await import('./gsap/marker-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            // Circles animation 
            if ( circlesAnimation ) {
                let AnimatedSection = await (await import('./gsap/circles-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            // drawSVG
            if ( circlesCharts ) {
                let drawSVG = await (await import('gsap/DrawSVGPlugin')).default;
                gsap.registerPlugin(drawSVG);
                
                let AnimatedSection = await (await import('./gsap/circles-chart')).default;
                AnimatedSection(gsap, ScrollTrigger, drawSVG);
            }

            if ( numberContent ) {
                let AnimatedSection = await (await import('./gsap/numbers')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( apps ) {
                let AnimatedSection = await (await import('./gsap/apps')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( imageAndContent ) {
                let AnimatedSection = await (await import('./gsap/image-and-content-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( centerAnimation ) {
                let AnimatedSection = await (await import('./gsap/center-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( heroDefaultAnimation ) {
                let AnimatedSection = await (await import('./gsap/hero-default-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
        }
    }
};

export const init = gsapController;